import { Http, Response, URLSearchParams } from '@angular/http';
import { AuthHttp } from 'angular2-jwt';
import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { Statique } from '../utils/statique';
import { SearchCriteriaTrackTrace } from '../utils/SearchCriteriaTrackTrace';
import "rxjs/add/operator/map";
import { EbPslApp } from '../classes/pslApp';
import { TTEvent } from '../classes/tTEvent';
import { EbTracing } from '../classes/tracing';
import { EbDemande } from '../classes/demande';

@Injectable()
export class TrackTraceService {

	Statique = Statique;
	constructor(private http: Http, private authHttp: AuthHttp) { }

	getEbTracing(searchCriteria: SearchCriteriaTrackTrace) {
		return this.authHttp
			.post(Statique.controllerTrackTrace + "/getEbTracing", searchCriteria)
			.map((res: Response) => res.json());
	}

	updateEbPslApp(ebPslApp: EbPslApp) {
		return this.authHttp
			.post(Statique.controllerTrackTrace + "/updateEbPslApp", ebPslApp)
			.map((res: Response) => res.json());
	}

	updateEbPslAppMasse(listPslApp:Array<EbPslApp>) {
		return this.authHttp
			.post(Statique.controllerTrackTrace + "/updateEbPslAppMasse", listPslApp)
			.map((res: Response) => res.json());
	}

	addDeviationMasse(listTTEvent:Array<TTEvent>) {
		return this.authHttp
			.post(Statique.controllerTrackTrace + "/addDeviationMasse", listTTEvent)
			.map((res: Response) => res.json());
	}

	addDeviation(tTEvent: TTEvent) {
		return this.authHttp
			.post(Statique.controllerTrackTrace + "/addDeviation", tTEvent)
			.map((res: Response) => res.json());
	}

	addTrackTrace(ebDemande: EbDemande) {
		return this.authHttp
			.post(Statique.controllerTrackTrace + "/addTrackTrace", ebDemande)
			.map((res: Response) => res.json());
	}

	getListEbTracingByEbDemandeNum(ebDemandeNum: number) {
		return this.authHttp
			.post(Statique.controllerTrackTrace + "/getListEbTracingByEbDemandeNum", ebDemandeNum)
			.map((res: Response) => res.json());
	}

	addOrRemoveTracing(listTracking: Map<number, EbTracing>, ebTtTracingNum: number, configPsl: string, event: HTMLElement) {
		if (listTracking.has(ebTtTracingNum)) {
			let ebTracing = listTracking.get(ebTtTracingNum);
				listTracking.delete(ebTtTracingNum);
		}
		else {
			let ebTracing: EbTracing = new EbTracing();
			ebTracing.ebTtTracingNum = ebTtTracingNum;
			ebTracing.configPsl = configPsl;
			listTracking.set(ebTtTracingNum,ebTracing);
		}

	}

	 getHtmlTracing(listTracking: Map<number, EbTracing>, ebTtTracingNum: number, configPsl: string) {
		let style = "font-size: 20px;cursor: pointer;";
		let _type = "checkbox";
    return "<input class='checkbox-Track'  id="+ebTtTracingNum+"  type='"+ _type  +"' style='" + style + "'onchange='functions.clickCheckbox(" + ebTtTracingNum + ",\""+configPsl+"\",event.target)'>";
	}

	getListEbIncotermPsl(){
		return this.authHttp
			.get(Statique.controllerTrackTrace + "/getListEbIncotermPsl")
			.map((res: Response) => res.json());
	}

	AddAllTracing(searchCriteria: SearchCriteriaTrackTrace) {
		return this.authHttp.post(Statique.controllerTrackTrace + "/addTrackToAllDemande",searchCriteria)
			.map((res: Response) => res.json());
	}

}



// WEBPACK FOOTER //
// ./src/app/services/trackTrace.service.ts